// -----------------------------------------------------------------------------
// Scripts for works slider
// -----------------------------------------------------------------------------

$(function () {
  const communitySlider = $('.community-slider');

  $.each(communitySlider, function(index, value) {
    const worksSlider = $(this).find('.works-slider').attr('id');
    const worksSliderAutoplay = $(this).find('.works-slider').attr('data-slider-autoplay');

    $(`#${worksSlider}`).slick({
      centerMode: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: worksSliderAutoplay === '1' ? true : false,
      arrows: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
      ]
    });
  });
});